import { BFF_API_ROUTES } from 'constants/apiRoutes';

import { baseRTKApi } from 'shared/api/baseApi';
import type { TLoansContactData, TLoansContactResponse } from 'shared/types/TLoansService';

export const sendLoansContactDataApi = baseRTKApi.injectEndpoints({
  endpoints: (build) => ({
    sendLoansContactData: build.mutation<TLoansContactResponse, TLoansContactData>({
      query: (query) => ({
        url: BFF_API_ROUTES.sendContact,
        method: 'POST',
        body: query,
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});
